import { z } from "zod";
import { AccountUserSchema } from "./AccountUser";
import { BaseChangelogSchema } from "./Changelog";

export const CommissionChangelogSchema = BaseChangelogSchema.extend({
  accountUser: AccountUserSchema.nullable(),
});
export const PartialCommissionChangelogSchema =
  CommissionChangelogSchema.deepPartial();

export type PartialCommissionChangelog = z.infer<
  typeof PartialCommissionChangelogSchema
>;

export type CommissionChangelog = z.infer<typeof CommissionChangelogSchema>;
